import { Tlt } from "@clairejs/react";
import { Link } from "@clairejs/react-web";
import { Button } from "antd";

interface Props {
    visibleButton?: boolean;
}
export default function LoginGroup(props: Props) {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                gap: 21,
                flexWrap: "wrap",
            }}>
            <Link style={{ flex: 1 }} to="/login">
                <Button style={{ width: "100%" }} type={props.visibleButton ? "default" : "link"}>
                    <Tlt template="Sign in" />
                </Button>
            </Link>
            <Link style={{ flex: 1 }} to="/signup">
                <Button style={{ width: "100%" }} type="primary">
                    <Tlt template="Register account" />
                </Button>
            </Link>
        </div>
    );
}
